export function googleRequest(request) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(Error('Google Calendar не ответил. Изменение будет повторено.')), 30000);
    try {
      request.execute(response => {
        clearTimeout(timer);
        if (response?.error) reject(response.error); else resolve(response || {});
      });
    } catch (error) { clearTimeout(timer); reject(error); }
  });
}
export function googleAccountMatches(auth2, email) {
  return !!email && auth2?.isSignedIn.get() === true &&
    auth2.currentUser.get()?.getBasicProfile()?.getEmail()?.toLowerCase() === email.toLowerCase();
}
export async function insertPersonalEvent(gapi, { googleEventId, lessonId, email, start, end }) {
  const resource = { id: googleEventId, summary: 'Урок',
    start: { dateTime: start.toISOString(), timeZone: 'Europe/Rome' },
    end: { dateTime: end.toISOString(), timeZone: 'Europe/Rome' },
    extendedProperties: { private: { bookingLessonId: lessonId, bookingOwnerEmail: email } } };
  try { return await googleRequest(gapi.client.calendar.events.insert({ calendarId: 'primary', resource })); }
  catch (error) {
    if (Number(error.code) !== 409) throw error;
    const existing = await googleRequest(gapi.client.calendar.events.get({ calendarId: 'primary', eventId: googleEventId }));
    if (existing.extendedProperties?.private?.bookingLessonId !== lessonId || existing.extendedProperties?.private?.bookingOwnerEmail !== email)
      throw Error('Событие Google не соответствует этому уроку.');
    return existing;
  }
}
export async function deletePersonalEvent(gapi, googleEventId) {
  try { await googleRequest(gapi.client.calendar.events.delete({ calendarId: 'primary', eventId: googleEventId })); }
  catch (error) { if (![404, 410].includes(Number(error.code))) throw error; }
}
